import React, {FC} from "react"

import {Voucher} from "@irati/deals/types"
import StockType from "@irati/stock/enums/StockType"
import {CodeContext} from "@irati/deals/context"

import Code from "./Code"

interface Props {
  vouchers: Voucher[]
}

const BirthdayBoxTicket: FC<Props> = ({vouchers}) => {
  const codeVoucher = vouchers.find((voucher) => voucher.type === StockType.TEXT)
  const urlVoucher = vouchers.find((voucher) => voucher.type === StockType.URL)

  return (
    <div className="ticket_productTickets">
      <div className="ticket_ticketWrapper tickets_borderBottom">
        <div className="ticket_ticketWrapperInner">
          <CodeContext.Provider value={{shouldAutoOpenLink: false}}>
            <Code voucher={codeVoucher} externalLinks={{web: urlVoucher?.code}} />
          </CodeContext.Provider>
        </div>
      </div>
    </div>
  )
}

export default BirthdayBoxTicket
